import CurbsideLocationsSFC from "./CurbsideLocations.vue";
export type { ICurbsideLocationsEmits } from "./emits";
export type { ICurbsideLocationsProps } from "./props";
export const CurbsideLocations = CurbsideLocationsSFC;
